module.exports = __webpack_public_path__ + "img/QUICPAYFC.37aab748.png";